/* DesiTech sticky cart: proxies the native product ATC so Shiprocket Smart Cart can intercept it. */
if (!customElements.get('desitech-sticky-cart')) {
  class DesitechStickyCart extends HTMLElement {
    connectedCallback() {
      this.buttons=[...this.querySelectorAll('[data-sticky-add],[data-sticky-buy]')];
      this.price=this.querySelector('[data-prepaid-price]');
      const variantsNode=this.querySelector('[data-sticky-variants]') || this.querySelector('script[type="application/json"]');
      try { this.variants=variantsNode ? JSON.parse(variantsNode.textContent) : []; } catch(e) { this.variants=[]; }
      this.formatter=new Intl.NumberFormat(this.dataset.locale || 'en-IN',{style:'currency',currency:this.dataset.currency || 'INR'});
      this._booted=false;
      this.initWhenReady();
    }

    initWhenReady() {
      const boot=()=>{
        if(this._booted) return true;
        this.section=document.querySelector('[data-dep-root], [data-c100-root], [data-sw-root], .section-main-product');
        if(!this.section) return false;

        const form=this.getForm();
        if(!form || !form.querySelector('[name="add"]')) return false;

        this.abort=new AbortController();
        const options={signal:this.abort.signal};

        this.section.addEventListener('on:variant:change',e=>{this.variant=e.detail?.variant;this.sync();},options);
        this.section.addEventListener('change',()=>this.sync(),options);
        this.section.addEventListener('on:cart:error',()=>this.revealForm(),options);
        this.buttons.forEach(button=>button.addEventListener('click',()=>this.add(button),options));

        this.observer=new MutationObserver(()=>this.sync());
        this.observer.observe(this.section,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled','value']});

        if('ResizeObserver' in window){
          this.resize=new ResizeObserver(()=>document.body.style.setProperty('--desitech-sticky-cart-height',`${this.getBoundingClientRect().height + 12}px`));
          this.resize.observe(this);
        }

        this.initTicker();
        this._booted=true;
        this.sync();
        return true;
      };

      if(boot()) return;

      const tryBoot=()=>{
        if(boot()){
          clearInterval(this._initTimer);
          this._initTimer=null;
        }
      };

      if(document.readyState==='loading'){
        document.addEventListener('DOMContentLoaded',tryBoot,{once:true});
      } else {
        tryBoot();
      }

      this._initTimer=setInterval(tryBoot,200);
      setTimeout(()=>{if(this._initTimer){clearInterval(this._initTimer);this._initTimer=null;}},10000);
    }

    initTicker(){
      const label=this.querySelector('[data-sticky-ticker]');
      const node=this.querySelector('[data-sticky-messages]');
      if(!label||!node||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
      let messages=[];try{messages=JSON.parse(node.textContent).filter(Boolean)}catch(e){}
      if(messages.length<2)return;
      let i=0;
      this.ticker=setInterval(()=>{
        i=(i+1)%messages.length;
        label.classList.add('is-changing');
        setTimeout(()=>{label.textContent=messages[i];label.classList.remove('is-changing')},160);
      },3500);
    }

    getForm() {
      return this.section?.querySelector('product-form .js-product-form, form.js-product-form');
    }

    getCurrentVariant(form) {
      const id=form?.querySelector('[name="id"]')?.value;
      const native=this.section?.querySelector('variant-picker, desitech-cover-picker, desitech-variant-picker');
      const selected=native?.getVariantData?.();
      return selected || (String(this.variant?.id)===String(id) ? this.variant : this.variants.find(v=>String(v.id)===String(id)));
    }

    sync() {
      const form=this.getForm();
      const main=form?.querySelector('[name="add"]');
      this.hidden=!main;
      document.body.classList.toggle('desitech-has-sticky-cart',!!main);
      if(!main) return;

      const id=form.querySelector('[name="id"]')?.value;
      const variant=this.getCurrentVariant(form);
      const busy=main.getAttribute('aria-disabled')==='true';
      const disabled=busy || (!!id && (main.disabled || variant?.available===false));

      this.buttons.forEach(button=>{
        button.disabled=disabled;
        if(button.hasAttribute('data-sticky-add')) button.textContent=!id ? (this.dataset.caseCover==='true' ? 'PICK PHONE MODEL' : 'CHOOSE OPTIONS') : variant?.available===false ? this.dataset.soldOutLabel : 'ADD TO CART';
        if(button.hasAttribute('data-sticky-buy')) button.textContent=!id ? (this.dataset.caseCover==='true' ? 'CHOOSE COLOUR' : 'CHOOSE OPTIONS') : variant?.available===false ? this.dataset.soldOutLabel : 'BUY NOW';
        button.setAttribute('aria-busy',String(busy));
      });

      if(this.price){
        if(variant && Number.isFinite(Number(variant.price))){
          const variantPrice=Number(variant.price);
          const customFactor=parseFloat(this.dataset.prepaidFactor);
          const finalPrice=this.dataset.caseCover==='true'
            ? variantPrice
            : Number.isFinite(customFactor)
              ? Math.round(variantPrice * customFactor)
              : Math.round(variantPrice * .85);
          this.price.textContent=this.formatter.format(finalPrice/100);
        } else {
          this.price.textContent=this.dataset.caseCover==='true' ? 'Choose model & colour' : 'Select a variant';
        }
      }
    }

    revealForm(button) {
      let target;
      if(this.dataset.caseCover==='true') {
        const kind=button?.hasAttribute('data-sticky-buy')?'colour':'model';
        target=this.section?.querySelector('[data-cc-kind="'+kind+'"]');
      }
      target=target || this.section?.querySelector('desitech-variant-picker, variant-picker, .dt-cover-options') || this.getForm();
      target?.scrollIntoView({behavior:'smooth',block:'center'});
    }

    add(button) {
      const form=this.getForm();
      const main=form?.querySelector('[name="add"]');
      if(!main) return;
      if(!form.querySelector('[name="id"]')?.value){this.revealForm(button);return;}
      if(main.disabled || main.getAttribute('aria-disabled')==='true') return;

      const component=form.closest('product-form');
      if((component?.validate && !component.validate()) || !form.reportValidity()){this.revealForm();return;}

      /* Both sticky ATC and BUY NOW deliberately proxy the native ATC click.
         Shiprocket Smart Cart can intercept the same native click and open its drawer. */
      main.click();
      this.sync();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
      clearInterval(this.ticker);
      clearInterval(this._initTimer);
      document.body.classList.remove('desitech-has-sticky-cart');
      document.body.style.removeProperty('--desitech-sticky-cart-height');
    }
  }
  customElements.define('desitech-sticky-cart',DesitechStickyCart);
}